module.exports = __webpack_public_path__ + "static/media/send.e67ba1cc.svg";